import { readPrimaryEnvironmentDescriptor } from "../environments/primary/context";
import { resolveCloudSignInActive } from "../lib/firstAccountSetup";
import {
  isClaudeCloudSignInEnabled,
  useCloudProviderSignIn,
  type CloudProviderSignInController,
} from "./useCloudProviderSignIn";
import type { CmmdClaudeCredentialState } from "../environments/cmmdApi";

export interface ClaudeCloudSignIn {
  /** True when this surface should route personal Claude sign-in through the auth VM. */
  readonly active: boolean;
  readonly controller: CloudProviderSignInController<CmmdClaudeCredentialState>;
}

/**
 * Card 1359 (Claude) — whether personal Claude sign-in runs on a throwaway auth
 * VM here, plus the controller that drives it.
 *
 * Two conditions, both required: the build flag is on, AND this surface has no
 * execution plane. An execution-plane surface (desktop, local web, a user
 * runtime) can run `claude auth login --claudeai` itself; routing it through
 * the auth VM would spend a VM and bypass the working local path. The predicate
 * is shared with onboarding so the two surfaces cannot disagree.
 *
 * Lives here rather than inline in SettingsPanels.tsx: that file is a ~5k-line
 * god file, and `.agents/rules/frontend-architecture.md` requires extraction
 * before adding to one.
 */
export function useClaudeCloudSignIn(): ClaudeCloudSignIn {
  const active = resolveCloudSignInActive({
    descriptor: readPrimaryEnvironmentDescriptor(),
    enabled: isClaudeCloudSignInEnabled(),
  });
  const controller = useCloudProviderSignIn({ provider: "claudeAgent", enabled: active });
  return { active, controller };
}
